/**
 * Chat 메시지 시간 표시 — `HH:MM` (24시간). MessageItem / AiTextMessage / 향후 sub-card 들이 공유.
 *
 * 잘못된 ISO 또는 NaN epoch → null (호출자가 미렌더). 시안 line 1184 의 `msg.time` 미리 포맷된
 * 문자열 사례를 frontend 에서 일관 derive (지연 도착 메시지 / IME 가 도착한 보낸 메시지 /
 * SSE backfill 등 모든 경로에서 동일 표기).
 */
export function formatMessageTime(iso: string): string | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const hh = d.getHours().toString().padStart(2, '0');
  const mm = d.getMinutes().toString().padStart(2, '0');
  return `${hh}:${mm}`;
}
